export default __webpack_public_path__ + "static/media/objectives_icon_3.b87a3e31.png";